import { camelize, getDateTypeIndex } from '@src/packages/dashboard/utils';

export const transformChartData = (result, filters, intl, chartGroupBy) => {
  let { data: agg } = camelize(result);
  
  if (!agg) {
    return {
      data: {
        metrics: [],
        info: {
          totalEvents: 0,
          division: {},
          eventType: {},
          trigger: {},
        },
      },
    };
  }

  const hits = agg?.hits || {};
  const totalEvents = agg?.aggregations?.timeRange?.docCount ?? 0;
  const extraInfo = hits?.hits?.[0]?.source;

  const buckets = agg?.aggregations?.timeRange?.histogram?.buckets;
  
  if (!buckets || !Array.isArray(buckets)) {
    return {
      data: {
        metrics: [],
        info: {
          totalEvents,
          division: extraInfo?.division || {},
          eventType: extraInfo?.eventType || {},
          trigger: extraInfo?.trigger || {},
        },
      },
    };
  }

  const formatedData = buckets.map(({ key, componentsNested }) => {
    const { numberStats } = componentsNested?.filterEventType || {};
    return {
      key: getDateTypeIndex(key, chartGroupBy, intl),
      avg: numberStats?.avg || 0,
      count: numberStats?.count || 0,
      max: numberStats?.max || 0,
      min: numberStats?.min || 0,
      sum: numberStats?.sum || 0,
    };
  });

  return {
    data: {
      metrics: formatedData,
      info: {
        totalEvents,
        division: extraInfo?.division || {},
        eventType: extraInfo?.eventType || {},
        trigger: extraInfo?.trigger || {},
      },
    },
  };
};

